module.exports = __webpack_public_path__ + "img/changlong.c4099e3c.jpg";